import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {Workflow} from '../../../model/Workflow';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Constant} from '../../../../global/util/Constant';
import {AuthService} from '../../../service/auth/auth.service';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../service/application.service';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import {StringUtil} from '../../../../global/util/StringUtil';
import {Template} from '../../../model/Template';
import {Document} from '../../../model/Document';
import {WorkflowDataService} from '../../../service/data/workflow-data.service';

@Component({
  selector: 'app-add-document-batch',
  templateUrl: './add-document-notify-batch.component.html',
  styleUrls: ['./add-document-notify-batch.component.css']
})
export class AddDocumentNotifyBatchComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public allDocumentUpload: boolean;
  public documentForm: FormGroup;
  public templates: any[] = [];
  private arrayProgress: number[] = [];
  private files: number[] = [];
  public documents: any[] = [];
  // Tipo de notificaciones
  private type = 20;
  public fileSelected: boolean;
  public workflows: Workflow[] = [];
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public enterpriseIdSelected: number;
  public typeLoadSelected: number;
  public isTypeFile = true;
  public hasFiles = false;
  // valor que indica si los documento se cargaron
  public isUploaded = false;
  public uploadedDocument = false;
  public isDataSource = false;
  // es notificación programada
  public isScheduledNotify = false;
  public title = 'TITLE.ADD-DOCUMENT-NOTIFY';
  public workFlowSelected: Workflow;
  public templateSelected: Template;
  // fecha de notificación
  // asunto de la notificación
  public subject: string;
  public message: string;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              public documentService: DocumentService,
              public authenticationService: AuthService,
              private modalService: NgbModal,
              private router: Router,
              private applicationService: ApplicationService,
              private workflowDataService: WorkflowDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }


  ngOnInit() {
    // elimina la fecha de notificación de la memoria
    LocalStorage.removeItem('date2notify');
    this.message = '';
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      // this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseIdSelected);
      this.workflows = this.workflowDataService.getWorkflows();
    } else {
      this.workflows = LocalStorage.getWorkflowsByPerson();
    }
    // TODO Investigate and improvement pass values by reference and avoid a return of this.workflows
    this.workflows = this.workflows.filter(value => value.type === WorkflowType.NOTCER && value.send2Visualization);
    this.typeLoadSelected = 1;
    // @ts-ignore
    this.workFlowSelected = this.workflows[0];
    this.isDataSource = this.workflows[0].xmlAsDatasource;
    this.isScheduledNotify = this.workflows[0].scheduledNotify;
    this.createForm();
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);
    this.getTemplates();
  }

  /**
   * Obtiene la lista de plantillas disponibles para la empresa del usuario
   */
  getTemplates() {
    this.loading = true;
    const templateUrl = Constant.ROOT_API_V1
      .concat('/templates1/')
      .concat('?partnerId=')
      .concat(String(0))
      .concat('&enterpriseId=')
      .concat(String(this.enterpriseIdSelected))
      .concat('&description=')
      .concat(String(''))
      .concat('&startDate=')
      .concat(String(''))
      .concat('&endDate=')
      .concat(String(''))
      .concat('&showAll=')
      .concat(String(true));
    this.documentService.get(templateUrl).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.templates = next._embedded.template;
        this.templateSelected = this.templates[0];
      } else {
        this.templates = [];
      }
    }, () => {
      this.loading = false;
    });
  }

  ngOnDestroy() {
    const items = [
      'others'];
    LocalStorage.removeItems(items);
  }

  /**
   * Realiza la carga de los documentos a notificar(NOTCER)
   */
  save(): void {
    if (this.documentForm.invalid) {
      Object.values(this.documentForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    let date2notify;
    if (!this.isScheduledNotify) {
      date2notify = '';
    } else {
      date2notify = LocalStorage.getDate2Notify();
    }
    let index = 0;
    let time = 1000;
    const batchCode = StringUtil.randomString(12);
    this.documents.forEach(document => {
      /*        if(index === 0 || group.value.)*/
      setTimeout(() => {
        const formData = new FormData();
        formData.append('batchCode', String(batchCode));
        formData.append('workflowId', String(this.workFlowSelected.id));
        formData.append('type', String(this.type));
        formData.append('documentNumber', document[0].subject);
        formData.append('subject', this.subject);
        formData.append('scheduledDate', String(date2notify));
        formData.append('files', document[0].file);
        this.documentService.upload2(formData).subscribe((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              break;
            case HttpEventType.ResponseHeader:
              break;
            case HttpEventType.UploadProgress:
              this.arrayProgress[index] = Math.round(event.loaded / event.total * 100);
              break;
            case HttpEventType.Response:
              index++;
              document.status = 'Subido';
              this.hasFiles = true;
              break;
          }
        }, error => {
          index++;
          document.status = 'No subido';
          this.hasFiles = true;
          if (error.status === HttpStatusCode.NOT_FOUND) {
            document.detail = 'Persona no encontrada con el número de documento indicado.';
          }
          if (error.status === HttpStatusCode.NOT_ACCEPTABLE) {
            document.detail = 'Asunto del documento no cumple con el formato.';
          }
        });
      }, time);
      time = time + 1000;
    });
    const interval = setInterval(() => {
      this.allDocumentUpload = true;
      this.loading = true;
      let complete = true;
      for (const progress of this.arrayProgress) {
        if (progress !== 100) {
          complete = false;
        }
      }
      if (complete) {
        clearInterval(interval);
        this.allDocumentUpload = true;
        this.loading = false;
      }
    }, 300);
  }

  cancel(): void {
    if (this.allDocumentUpload) {
      LocalStorage.removeItem('date2notify');
      this.activeModal.close(InformType.Success);
    } else {
      LocalStorage.removeItem('date2notify');
      this.activeModal.close();
    }
  }

  private createForm() {
    this.documentForm = this.formBuilder.group(
      {
        workflow: [],
        template: [],
        subject: ['', [Validators.required]],
        rubricFilename2Show: [],
        rubricFilename2Show1: [],
        rubricFilename2Show2: [],
        typeLoad: [],
        filename: [],
      });
  }

  public isInvalidControl(ctrlName: string) {
    return this.documentForm.get(ctrlName).invalid && this.documentForm.get(ctrlName).touched;
  }

  public getProgress(index: number): number {
    return this.arrayProgress[index];
  }

  /**
   * Obtiene total de documentos cargados
   */
  public getTotal(): string {
    const upload = this.documents.filter(document => document.loaded).length;
    const total = this.documents.length;
    return upload + ' de ' + total;
  }

  public deleteRow(document: any) {
    const index = this.getIndexOf(document);
    this.documents.splice(index, 1);
  }

  public reload(isTypeFileSelected: number) {
    if (Number(isTypeFileSelected) === 1) {
      this.isTypeFile = true;
      this.documentForm.get('rubricFilename2Show').setValidators(Validators.required);
      this.documentForm.get('rubricFilename2Show').updateValueAndValidity();
      this.documentForm.get('rubricFilename2Show1').clearValidators();
      this.documentForm.get('rubricFilename2Show1').updateValueAndValidity();
      this.documentForm.get('rubricFilename2Show2').clearValidators();
      this.documentForm.get('rubricFilename2Show2').updateValueAndValidity();
    } else {
      this.isTypeFile = false;
      this.documentForm.get('rubricFilename2Show1').setValidators(Validators.required);
      this.documentForm.get('rubricFilename2Show1').updateValueAndValidity();
      this.documentForm.get('rubricFilename2Show').clearValidators();
      this.documentForm.get('rubricFilename2Show').updateValueAndValidity();
      this.documentForm.get('rubricFilename2Show2').clearValidators();
      this.documentForm.get('rubricFilename2Show2').updateValueAndValidity();
    }
    if (this.workFlowSelected.scheduledNotify && !this.workFlowSelected.xmlAsDatasource) {
      this.message = this.translate.instant('MESSAGE.NOTCER-SCHEDULED-NOTIFY');
    } else if (this.workFlowSelected.xmlAsDatasource && !this.workFlowSelected.notifyAfterUpload
      && !this.workFlowSelected.scheduledNotify) {
      this.message = this.translate.instant('MESSAGE.NOTCER-DATA-SOURCE-NOTIFY');
    } else if (this.workFlowSelected.notifyAfterUpload && !this.workFlowSelected.xmlAsDatasource) {
      this.message = this.translate.instant('MESSAGE.NOTCER-NOTIFY-AFTER-UPLOAD');
    } else if (this.workFlowSelected.scheduledNotify && this.workFlowSelected.xmlAsDatasource) {
      this.message = this.translate.instant('MESSAGE.NOTCER-SCHEDULED-NOTIFY-DATA-SOURCE');
    } else if (this.workFlowSelected.xmlAsDatasource && this.workFlowSelected.notifyAfterUpload) {
      this.message = this.translate.instant('MESSAGE.NOTCER-NOTIFY-AFTER-UPLOAD-DATA-SOURCE');
    } else {
      this.message = '';
    }
    this.isDataSource = this.workFlowSelected.xmlAsDatasource;
    if (this.isDataSource) {
      this.documentForm.get('rubricFilename2Show2').setValidators(Validators.required);
      this.documentForm.get('rubricFilename2Show2').updateValueAndValidity();
      this.documentForm.get('rubricFilename2Show').clearValidators();
      this.documentForm.get('rubricFilename2Show').updateValueAndValidity();
      this.documentForm.get('rubricFilename2Show1').clearValidators();
      this.documentForm.get('rubricFilename2Show1').updateValueAndValidity();
    }
    this.isScheduledNotify = this.workFlowSelected.scheduledNotify;
  }

  public hasDate2Notify(): boolean {
    if (this.isScheduledNotify) {
      const date2notify = LocalStorage.getDate2Notify();
      return date2notify != null;
    }
    return true;
  }

  /**
   * Estado de carga de documento por xml o excel
   */
  public getStatusUpload(document: Document): string {
    return document.loaded ? 'Carga completada' : 'Carga no completada';
  }

  /**
   * Detalle de carga de documento por excel o xml
   */
  public getErrorDetailUpload(document: Document): string {
    if (document.descriptionLoadError !== undefined) {
      return document.descriptionLoadError;
    } else {
      return '';
    }
  }

  public changeStatus(event) {
    // const fileSelected = (event.target as HTMLInputElement).files[0];
    this.files = event.target.files;
    this.uploadedDocument = true;
    for (let index = 0; index < event.target.files.length; index++) {
      const fileSelected = (event.target as HTMLInputElement).files[index];
      if (!fileSelected.name.endsWith('.pdf')) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
        return;
      }
      this.isUploaded = true;
      const subject1 = fileSelected.name.replace('.pdf', '');
      const statusDescription = '';
      const detailError = '';
      const unique: any[] = [{
        file: fileSelected,
        filename: fileSelected.name,
        subject: subject1,
        status: statusDescription,
        detail: detailError
      }];
      this.documents.push(unique);
    }
  }

  public changeStatus1(event) {
    // const fileSelected = (event.target as HTMLInputElement).files[0];
    this.files = event.target.files;
    this.uploadedDocument = true;
    const xlsFile = (event.target as HTMLInputElement).files[0];
    // this.workFlowSelected = this
    this.loading = true;
    let date2notify;
    if (!this.isScheduledNotify) {
      date2notify = '';
    } else {
      date2notify = LocalStorage.getDate2Notify();
    }
    this.isUploaded = true;
    const url = Constant.ROOT_API_V1.concat('/document/workflow/', String(this.workFlowSelected.id));
    const batchCode = StringUtil.randomString(12);
    const formData = new FormData();
    formData.append('batchCode', String(batchCode));
    formData.append('subject', String(this.subject));
    formData.append('type', String(this.type));
    formData.append('scheduledDate', String(date2notify));
    formData.append('templateId', String(this.templateSelected.id));
    formData.append('xlsFile', xlsFile);
    // tslint:disable-next-line:no-shadowed-variable
    this.documentService.upload3(url, formData).subscribe((event: HttpEvent<any>) => {
      this.hasFiles = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.arrayProgress[0] = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.loading = false;
          this.documents = event.body;
          break;
      }
    }, response => {
      this.loading = false;
      this.activeModal.close({informType: InformType.Danger, message: response.error.message});
    });
  }

  get hideDeleteItemOnlyRecord() {
    return this.documents.length === 1;
  }

  /**
   * Obtiene un fila de la lista
   * @param workflow
   * @private
   */
  private getIndexOf(workflow: any): number {
    return this.documents.findIndex(value => value.id === workflow.id);
  }

  get allDocumentAreaUpload() {
    return this.allDocumentUpload;
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  viewParams(): void {
    const message = this.translate.instant('MESSAGE.FORMANT-ALLOWED-IN-SUBJECT')
      .concat('<ul>')
      .concat('<li>Si la persona que será notificada  tiene <b>DNI</b>, se debe agregar el "01" antes de su número de documento, EJEMPLO:<b> 01_70607431</b></li>')
      .concat('<li>Si la persona que será notificada  tiene <b>CARNÉ DE ENTRANJERÍA</b>, se debe agregar el "04" antes de su número de documento, EJEMPLO:<b> 04_7060743122</b></li>')
      .concat('<li>Si la persona que será notificada  tiene <b>PASAPORTE</b>, se debe agregar el "07" antes de su número de documento, EJEMPLO:<b> 07_70607431333</b></li>')
      .concat('</ul>')
      .concat('<b>Notificación con fuente de datos</b>')
      .concat('<br>Para las notificaciones con fuente de datos, la primera colunma del archivo Excel o primer nodo del archivo XML debe tener como parametro <b>subject</b><br><br>')
      .concat(this.translate.instant('MESSAGE.NOTE'));
    Dialog.show(InformType.Info, this.translate.instant('TITLE.FORMAT-DOCUMENT'), message);
  }

  /**
   * Muestra mensaje de error de acuerdo a controlname
   */
  public getErrorMessageBy(controlName: string): string {
    const control = this.documentForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasPatternError = control.hasError('pattern');
    let actualValue;
    switch (controlName) {
      case 'subject':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.SUBJECT-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
      case 'rubricFilename2Show':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FILE-ARE-REQUIRED');
        }
        break;
      case 'rubricFilename2Show1':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FILE-ARE-REQUIRED');
        }
        break;
      case 'rubricFilename2Show2':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FILE-ARE-REQUIRED');
        }
        break;
    }
  }
}
